(function() {
    /**
     *
     */
    angular.module('graph').factory('ph-broadcast', ['$rootScope', '$q', function ($root, $q) {
        /**
         *
         */
        var $broadcast = io({transports: ['websocket'], path: "/broadcast/"});

        /**
         *
         */
        return {
            "on": function ($event, $call) {
                /**
                 *
                 */
                $broadcast.on($event, function ($data) {
                    $call($data, $data['guid']);
                    $root.$apply();
                });
            },
            "emit": function ($event, $data) {
                $broadcast.emit($event, $data);
            }
        };
    }]);

    /**
     *
     */
    angular.module('graph').factory('ph-paging', function () {
        return {
            'new': function () {
                return {
                    'page'  : 0,
                    'pages' : -1,
                    'let'   : 0,
                    'items' : 0
                };
            }
        }
    });

    /**
     *
     */
    angular.module('graph').factory('ph-tooltip', ['ph-core', function ($core) {
        var $tooltips = [];

        function make($space)
        {
            var space = $space.split(':');

            var $entry = space[0] !== null && space[0] !== 'user' ? space[0] + '/' : '';
            $entry += space[1] !== 0 ? space[1] + '/' : '';

            return $entry;
        }

        return {
            'get' : function ($space, next) {
                if ($tooltips[$space] === undefined) {
                    $core.get('/xhr/' + make($space) + 'tooltips')
                        .then(function ($response) {
                            if ($response.data.state === 0) {
                                $tooltips[$space] = $response.data.data;

                                next($tooltips[$space]);
                            }
                        });
                } else
                    next($tooltips[$space]);
            }
        };

    }]);

    /**
     *
     */
    angular.module('graph').factory('ph-preview-storage', ['ph-core', 'ph-date-service', function ($core, $date) {
        var $preview = {
            prefix: 'analytic:preview:',
            get   : function (space, $query, next) {
                $core.get('/xhr/' +
                    space +
                    '/analytics?' +
                    $query
                ).then(function ($response) {
                    if ($response.data.state === 0) {
                        return next($response.data.data.preview);
                    }
                });
            }
        };

        var $localStorage = {
            available: function () {
                return (typeof localStorage !== 'undefined')
            },
            quotaExceeded: function () {
                try {
                    var key = '__test__key';
                    localStorage.setItem(key, key);
                    localStorage.removeItem(key);
                    return false;
                } catch(e) {
                    var quotaExceeded = false;
                    if (e.code) {
                        switch (e.code) {
                            case 22:
                                quotaExceeded = true;
                                break;
                            case 1014:
                                if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                                    quotaExceeded = true;
                                }
                                break;
                        }
                    } else if (e.number === -2147024882) {
                        quotaExceeded = true;
                    }
                    return quotaExceeded;
                }
            },
            has      : function (space) {
                return localStorage.getItem($preview.prefix + space) !== null;
            },
            get      : function (space) {
                return JSON.parse(localStorage.getItem($preview.prefix + space));
            },
            set      : function (space, data) {
                if ($localStorage.quotaExceeded() == false) {
                    localStorage.setItem($preview.prefix + space, JSON.stringify(data));
                } else {
                    localStorage.clear();
                }
            }
        };

        return {
            'get' : function (space, $query, next) {
                if ($localStorage.available()) {
                    if ($localStorage.has(space)) {
                        var $item = $localStorage.get(space);

                        if ($date.$now().diff($date.$parse($item['created_at']), 'days') > 1) {
                            $preview.get(space, $query, function (data) {
                                var $item = {
                                    created_at: $date.$now().format('YYYYMMDD'),
                                    updated_at: null,
                                    data      : data
                                };
                                $localStorage.set(space, $item);

                                return next(data)
                            });
                        }

                        $item['updated_at'] = $date.$now().format('YYYYMMDD');
                        $localStorage.set(space, $item);

                        return next($item['data']);
                    }
                }

                $preview.get(space, $query, function (data) {
                    if ($localStorage.available()) {
                        var $item = {
                            created_at: $date.$now().format('YYYYMMDD'),
                            updated_at: null,
                            data      : data
                        };
                        $localStorage.set(space, $item);
                    }

                    return next(data)
                });
            }
        };

    }]);

    /**
     *
     */
    angular.module('graph').factory('ph-core', ['$http', '$rootScope', 'ph-broadcast', '$q', 'ph-query-service', function ($http, $root, $broadcast, $q, $query) {
        function generate() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }

            return s4() + s4()
                + '-'
                + s4()
                + '-'
                + s4()
                + '-'
                + s4()
                + '-'
                + s4() + s4() + s4();
        };

        var $guid = generate();

        var $core = {
            "random": generate,
            "get": $http.get,
            "post": function ($url, $body, $subguid) {
                /**
                 *
                 */
                if (typeof $body !== 'object') {
                    $body = {};
                }

                /**
                 *
                 */
                return $http.post($url, $body, {
                    "headers": {
                        'X-Ph-Guid': $subguid ? $subguid : $guid
                    }
                });
            },
            "put": $http.put,
            "delete": function ($url, $subguid) {
                /**
                 *
                 */
                return $http.delete($url, {
                    "headers": {
                        'X-Ph-Guid': $subguid ? $subguid : $guid
                    }
                });
            },
            "$guid": $guid,
            "$object": {
                "replace": function (a, b) {
                    var prop;

                    // for ( prop in a ) delete a[prop];
                    for (prop in b) a[prop] = b[prop];
                }
            },
            "$array": {
                "find": function ($array, $id, $iterate, $after, $nfound) {
                    if ($array.length > 0) {
                        for (var $key = 0; $key < $array.length; $key++) {
                            if (
                                +($id) === +($array[$key].id)
                            ) {
                                $iterate($array[$key], $key);
                                return $after($array[$key], $key);
                            } else if (
                                $array.length === ($key + 1)
                            ) {
                                if ($nfound)
                                    return $nfound();
                            }
                        }
                    } else {
                        if ($nfound)
                            return $nfound();
                    }
                },
                "rm": function ($array, $id, $call, $fail) {
                    $core.$array.find($array, $id, function ($node, $key) {
                        $call($node);
                    }, function ($node, $key) {
                        $array.splice($key, 1);
                    }, $fail);
                }
            },
            "$with": {
                "lock": function ($fn) {
                    $root.screen_lock = 1;

                    var unlock = function($pfn) {
                        if ($pfn) $pfn();

                        $root.screen_lock = 0;
                    };

                    $fn(unlock);
                },
                "rm": function ($array, $id, $call, $fail) {
                    $core.$array.find($array, $id, function ($node, $key) {
                        $call($node);
                    }, function ($node, $key) {
                        $array.splice($key, 1);
                    }, $fail);
                }
            },
            $uri : {
                $query : $query
            }
        };

        return $core;
    }]);
})();
